import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';

const AdminCallback = () => {
  const navigate = useNavigate();
  const { processSessionId } = useAuth();
  const [processing, setProcessing] = useState(false);
  const hasExecuted = useRef(false);

  useEffect(() => {
    // Prevent multiple executions using ref (survives re-renders)
    if (hasExecuted.current) {
      console.log('AdminCallback: Already executed, skipping...');
      return;
    }
    
    const handleCallback = async () => {
      hasExecuted.current = true;
      setProcessing(true);
      
      console.log('AdminCallback: Starting authentication process...');
      
      try {
        // Get session_id from URL fragment
        const hash = window.location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('Authentication failed');
          navigate('/admin/login');
          return;
        }

        // Process session
        await processSessionId(sessionId);
        
        // Clean URL
        window.history.replaceState({}, document.title, '/admin/dashboard');
        
        console.log('AdminCallback: Authentication successful');
        toast.success('Successfully logged in!');
        navigate('/admin/dashboard');
      } catch (error) {
        console.error('AdminCallback: Authentication failed:', error);
        
        // Handle specific error cases
        if (error.response?.status === 403) {
          toast.error('Access denied. Your email is not authorized to access the admin panel.');
        } else {
          toast.error('Authentication failed');
        }
        
        navigate('/admin/login');
      } finally {
        setProcessing(false);
      }
    };

    handleCallback();
  }, []); // Empty dependency array to run only once

  return (
    <div className="admin-loading">
      <div className="loading-spinner"></div>
      <p className="loading-text">Authenticating...</p>
    </div>
  );
};

export default AdminCallback;
